import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Certificate } from '../../../../shared/models/certificate.models';
import { MatExpansionModule } from '@angular/material/expansion';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SnackbarComponent } from '../../../../shared/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClipboardModule } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-ssl-certificate-info-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatCheckboxModule,
    MatExpansionModule,
    FontAwesomeModule,
    ClipboardModule,
  ],
  templateUrl: './ssl-certificate-info-dialog.component.html',
  styleUrl: './ssl-certificate-info-dialog.component.scss',
})
export class SslCertificateInfoDialogComponent {
  readonly dialogRef = inject(MatDialogRef<SslCertificateInfoDialogComponent>);

  readonly data = inject<DialogData & { certificate: Certificate }>(MAT_DIALOG_DATA);

  private snackbar = inject(MatSnackBar);

  autoRenew = new FormControl(true);

  get aliases(): string {
    return this.data.certificate.altNames?.map((a) => a.name).join(', ');
  }

  get certificate(): string {
    return this.data.certificate.certificate;
  }

  get key(): string {
    return this.data.certificate.privateKey;
  }

  submit(): void {
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }

  onCopied(success: boolean, name: string) {
    if (success) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: {
          text: `${name} copied!`,
        },
      });
    }
  }
}
